export default {
  path: '/recent-actions',
  name: 'recent-actions',
  component: () => import(/* webpackChunkName: "recent-actions" */ './RecentActions'),
  meta: {
    requiresAuth: true,
    pageTitle: 'Recent Actions'
  }
}
